/*
 * @Descripttion: 新闻轮播
 * @Author: huangfuchunmei
 * @Date: 2023-08-30 13:49:39
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 18:07:17
 */
import React from "react";
import styles from "./index.module.scss";
import LazyMedia from "@/components/LazyMedia";
import { INews } from "@/common/types";
import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface ProductProps {
  newsContents: INews[]; // 新闻数据
  ctry?: string;
  words: Record<string, string>;
  device: string;
}

const NewsSlider: React.FC<ProductProps> = ({
  newsContents,
  words,
  device,
  ctry,
}) => {

  return (
    <>
      {newsContents && (
        <div className={styles["news-wrap"]}>
          <div className={styles["title-wrap"]}>
            <h2 className={styles["spread-head"]}>{words?.home_news_title}</h2>
            <h4 className={styles["sub-title"]}>
              {words?.home_news_description}
            </h4>
          </div>
          <NoSSR>
            <CustomSwiper
              swiperWrapClass={styles['custom-swiper-wrap']}
              swiperSlideClass={styles['custom-swiper-slider']}
              breakpoints={{
                0: {
                  spaceBetween: 24
                },
                1740: {
                  spaceBetween: 50
                }
              }}>
              {newsContents?.map((item: INews, index: number) => (
                <a href={`/${ctry}/newsroom/${item.seoUrl}`} key={item.id}>
                  <div
                    key={item.id}
                    className={`${
                      index === 0 ? styles["slider-item-first"] : ""
                    } ${styles["slider-item"]}`}
                    >
                    <LazyMedia type="image" src={item.cover} alt={item?.coverAlt} />
                    <div className={styles["slider-item-content-wrap"]}>
                        <h3>{item.title}</h3>
                        <p>{item.publishDate}</p>
                    </div>
                  </div>
                </a>
              ))}
            </CustomSwiper>
          </NoSSR>
        </div>
      )}
    </>
  );
};

export default NewsSlider;
